module.exports = __webpack_public_path__ + "img/lionel-messi.0a673409.png";